import React from 'react';

interface WordCountStats {
  pages: number;
  words: number;
  characters: number;
  charactersNoSpaces: number;
}

interface WordCountModalProps {
  /** Passed in from the editor, which is where the language hook lives */
  t: any;
  show: boolean;
  onClose: () => void;
  stats: WordCountStats;
  displayWhileTyping: boolean;
  onToggleDisplay: (value: boolean) => void;
}

export const WordCountModal: React.FC<WordCountModalProps> = ({
  t,
  show,
  onClose,
  stats,
  displayWhileTyping,
  onToggleDisplay,
}) => {
  if (!show) return null;

  return (
    <div className="word-count-modal-overlay" onClick={onClose}>
      <div className="word-count-modal" onClick={(e) => e.stopPropagation()}>
        <div className="word-count-modal-header">
          <h3>{t.editor.wordCount}</h3>
          <button 
            className="word-count-close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="word-count-stats">
          <div className="word-count-stat-row">
            <span className="word-count-label">{t.editor.pages}</span>
            <span className="word-count-value">{stats.pages}</span>
          </div>
          <div className="word-count-stat-row">
            <span className="word-count-label">{t.editor.words}</span>
            <span className="word-count-value">{stats.words}</span>
          </div>
          <div className="word-count-stat-row">
            <span className="word-count-label">{t.editor.characters}</span>
            <span className="word-count-value">{stats.characters}</span>
          </div>
          <div className="word-count-stat-row">
            <span className="word-count-label">{t.editor.charactersNoSpaces}</span>
            <span className="word-count-value">{stats.charactersNoSpaces}</span>
          </div>
        </div>
        <div className="word-count-options">
          <label className="word-count-checkbox">
            <input
              type="checkbox"
              checked={displayWhileTyping}
              onChange={(e) => onToggleDisplay(e.target.checked)}
            />
            <span>{t.editor.displayWordCountWhileTyping}</span>
          </label>
        </div>
      </div>
    </div>
  );
};

interface LiveWordCountProps {
  t: any;
  show: boolean;
  wordCount: number;
}

export const LiveWordCount: React.FC<LiveWordCountProps> = ({ t, show, wordCount }) => {
  if (!show) return null;

  return (
    <div className="live-word-count">
      <div className="live-word-count-content">
        <span className="live-word-count-label">{t.editor.wordsLabel}</span>
        <span className="live-word-count-value">{wordCount}</span>
      </div>
    </div>
  );
};
